import cx from "classnames";

import styles from "./Card.module.scss";

interface CardProps extends React.HTMLProps<HTMLDivElement> {
  children: React.ReactNode;
  className?: string;
}

const Card = ({ children, className, ...props }: CardProps) => {
  return (
    <div className={cx(styles.card, className)} {...props}>
      {children}
    </div>
  );
};

export default Card;
